module.exports = __webpack_public_path__ + "src/img/done.6f0e3563.svg";